<template>
  <div id="productModal" class="modal" :class="{ 'is-active' : isActive }">
    <div class="modal-background"></div>

    <div class="modal-content">
      <div v-if="product" class="card">
        <div v-if="hasImage" class="card-image">
          <figure class="image">
            <img :src="product.images[0]" alt="Afbeelding niet gevonden">
          </figure>
        </div>

        <div class="card-content">
          <div class="media">
            <!-- <div class="media-left">
              <figure class="image is-48x48">
                <img src="https://bulma.io/images/placeholders/96x96.png" alt="Placeholder image">
              </figure>
            </div> -->
            <div class="media-content">
              <p class="title is-4">{{ product.name }}</p>

              <p class="subtitle is-6">{{ product.supplier.name }}<br>
                <a :href="product.supplier.www" target="_blank">{{ product.supplier.www }}</a></p>
            </div>
          </div>

          <div class="content" v-html="product.description"></div>

          <div v-show="product.images.length" class="content">
            <h2 class="title is-5">Afbeeldingen</h2>
            <figure v-for="image in product.images" class="image">
              <img :src="image.file" alt="Image not found">
              <h3 v-show="hasName(image)" class="subtitle is-6">{{ image.name }}</h3>
              <div v-show="hasCaption(image)" class="content" v-html="image.caption"></div>
            </figure>
          </div>

          <div class="content">
            <button type="button" class="button" @click="add">Toevoegen aan collectie</button>
          </div>
        </div>
      </div>
    </div>

    <button class="modal-close is-large" aria-label="close" @click="close"></button>
  </div>
</template>

<script>
export default {
  props: [
    'product'
  ],
  computed: {
    isActive () {
      return this.product !== null
    },
    hasImage () {
      return this.product.images.length > 0
    }
  },
  methods: {
    add () {
      this.$emit('add')
    },
    close () {
      this.$emit('close')
    },
    hasName (image) {
      return image.name
    },
    hasCaption (image) {
      return image.caption
    }
  }
}
</script>

<style scoped>
  .image .subtitle {
    margin-top: 0 !important;
    margin-bottom: 5px !important;
    text-align: left;
  }

  .image .content {
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/products/ProductModal.vue